<template>
  <el-form ref="form" :model="formData" :rules="rules" :show-message="false">
    <table class="table">
      <tr class="gray-bg">
        <td>{{$t('版本')}}</td>
        <td>{{$t('单位名称')}}</td>
        <td>{{$t('换算率（1克=？）')}}</td>
        <td>{{$t('换算率（1单位=？克）')}}</td>
      </tr>

      <tr>
        <td class="gray-bg">{{$t('中文')}}</td>
        <td>
          <el-form-item prop="cnName">
            <el-input :placeholder="$t('单位名称')" v-model="formData.cnName" />
          </el-form-item>
        </td>
        <td>
          <el-form-item prop="cnRate">
            <el-input :placeholder="$t('换算率（1克=？）')" v-model="formData.cnRate" />
          </el-form-item>
        </td>
        <td>
          <el-form-item prop="cnRateUnit">
            <el-input :placeholder="$t('换算率（1单位=？克）')" v-model="formData.cnRateUnit" />
          </el-form-item>
        </td>
      </tr>

      <tr>
        <td class="gray-bg">{{$t('英文')}}</td>
        <td>
          <el-form-item prop="enName">
            <el-input :placeholder="$t('单位名称')" v-model="formData.enName" />
          </el-form-item>
        </td>
        <td>
          <el-form-item prop="enRate">
            <el-input :placeholder="$t('换算率（1克=？）')" v-model="formData.enRate" />
          </el-form-item>
        </td>
        <td>
          <el-form-item prop="enRateUnit">
            <el-input :placeholder="$t('换算率（1单位=？克）')" v-model="formData.enRateUnit" />
          </el-form-item>
        </td>
      </tr>

      <tr class="gray-bg">
        <td>{{$t('展示优先级')}}</td>
        <td>{{$t('展示优先级协议代码')}}</td>
        <td>{{$t('单位协议代码')}}</td>
        <td>{{$t('备注')}}</td>
      </tr>

      <tr>
        <td>
          <el-form-item prop="priority">
            <el-input :placeholder="$t('展示优先级')" v-model="formData.priority" />
          </el-form-item>
        </td>
        <td>
          <el-form-item prop="showProtocolCode">
            <el-input :placeholder="$t('展示优先级协议代码')" v-model="formData.showProtocolCode" />
          </el-form-item>
        </td>
        <td>
          <el-form-item prop="unitProtocolCode">
            <el-input :placeholder="$t('单位协议代码')" v-model="formData.unitProtocolCode" />
          </el-form-item>
        </td>
        <td>
          <el-form-item>
            <el-input :placeholder="$t('备注')" v-model="formData.remark" />
          </el-form-item>
        </td>
      </tr>
    </table>

    <div class="flex-center mt16">
      <el-button type="primary" @click="handleConfirm">{{$t('确认')}}</el-button>
      <el-button @click="resetForm">{{$t('重置')}}</el-button>
    </div>
  </el-form>
</template>

<script>
import {resetEmpty} from "@/utils/common";

export default {
  name: "UnitForm",
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        cnName: "",
        enName: "",
        cnRate: "",
        enRate: "",
        cnRateUnit: "",
        enRateUnit: "",
        priority: "",
        showProtocolCode: "",
        unitProtocolCode: "",
        remark: ""
      },
      rules: {
        cnName: {required: true, message: this.$t('请输入中文名称'), trigger: "blur"},
        enName: {required: true, message: this.$t('请输入英文名称'), trigger: "blur"},
        cnRate: {required: true, message: this.$t('请输入中文换算率'), trigger: "blur"},
        enRate: {required: true, message: this.$t('请输入英文换算率'), trigger: "blur"},
        cnRateUnit: {required: true, message: this.$t('请输入中文换算率单位'), trigger: "blur"},
        enRateUnit: {required: true, message: this.$t('请输入英文换算率单位'), trigger: "blur"},
        priority: {required: true, message: this.$t('请输入优先级'), trigger: "blur"},
        showProtocolCode: {required: true, message: this.$t('请输入展示优先级协议代码'), trigger: "blur"},
        unitProtocolCode: {required: true, message: this.$t('请输入单位协议代码'), trigger: "blur"},
      }

    }
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate((valid, error) => {
        this.handleShowError(error);
        if(!valid) return;
        this.$emit("confirm", this.formData);
      })
    },

    handleShowError(obj) {
      const keys = Object.keys(obj);
      if(!keys.length) return;
      const firstKey = keys[0];
      this.$message.error(obj[firstKey][0].message);
    },

    resetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
    }
  },
  watch: {
    data: {
      handler(val) {
        for (const key in this.formData) {
          this.formData[key] = val[key];
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">

.table {
  width: 100%;
  border-collapse: collapse;

  td {
    box-sizing: border-box;
    padding: 14px;
    border: 1px solid #ddd;
  }

  .gray-bg {
    background: #efefef;
  }

  td {
    text-align: center;
  }
}

.el-form-item {
  padding: 0;
  margin: 0;
}

</style>
